import React from 'react';
import Config from 'config';
import QueryString from 'qs';
import useContext from '../../../../../hooks/useContext';
import { useApiaComponentContext } from '../../apiaComponent/ApiaComponentContext';
import {
  TProcessSubmitFieldParams,
  TProcessSubmitFieldResponse,
} from '../../../../../store/valuesSlice';
import ApiaApi from '../../../../../api/apiaApi/apiaApi';
import { ApiaFormContext } from '../../page/ApiaForm';
import propsStore from '../../../../../store/propsStore/propsStore';

export interface IProcessSubmitFieldProperties {
  [key: string]: unknown;
}

async function processFieldSubmit({
  postData,
  params,
}: {
  postData: unknown;
  params: TProcessSubmitFieldParams;
}) {
  const response = await ApiaApi.post<TProcessSubmitFieldResponse>(
    Config.PROCESS_FIELD_SUBMIT_URL,
    {
      queryData: params.params,
      postData,
      stringifyOptions: { arrayFormat: 'repeat' },
    },
  );
  return response?.data as TProcessSubmitFieldResponse;
}

export default function useProcessFieldSubmit() {
  const { fieldId } = useApiaComponentContext();
  const { formData, frmParent } = useContext(ApiaFormContext);
  const getParamsForProcessFieldSubmit = React.useCallback(() => {
    const props = propsStore.getFieldProps(fieldId);
    const { attributes } = props;
    let idx;
    if (attributes && formData) {
      if (Config.IS_EDIT_GRID_MODAL) {
        idx = Config.MODAL_INDEX;
      } else {
        idx = attributes?.index;
      }
      const processSubmitParams: TProcessSubmitFieldParams = {
        id: fieldId,
        params: {
          attId: props.attId ?? attributes?.attId,
          frmId: formData.id,
          index: props.field?.multIdx ?? idx,
          frmParent,
          timestamp: Date.now(),
          ...(window.IS_EDIT_GRID_MODAL ? { editionMode: true } : undefined),
        },
      };
      return processSubmitParams;
    }
    return null;
  }, [formData, fieldId, frmParent]);

  /**
   * Este método debe ser llamado con un objeto como parámetro con la forma
   * {
   *  submitValue: unknown - El valor que será enviado al servidor.
   *  ...Cualquier otro parámetro que se quiera enviar al servidor.
   * }
   */
  const fieldSubmit = React.useCallback(
    async function fieldSubmit(postData: IProcessSubmitFieldProperties) {
      if (window.IN_MONITOR) {
        return false;
      }

      const pfsParams = getParamsForProcessFieldSubmit();
      if (!pfsParams)
        throw new Error('Get params for processFieldSubmit failed');
      const processSubmitResponse = await processFieldSubmit({
        postData: QueryString.stringify(postData, { arrayFormat: 'repeat' }),
        params: pfsParams,
      });
      return processSubmitResponse?.success ?? false;
    },
    [getParamsForProcessFieldSubmit],
  );

  return fieldSubmit;
}
